import styled from 'styled-components';
import Icon from '../../../atoms/Icon';

const Wrapper = styled.div`
  height: ${(props) => props.theme.header.heightMobile}px;
  min-width: ${(props) => props.theme.header.heightMobile}px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.color.primary800};

  @media (${(props) => props.theme.header.mobileSwitch}) {
    min-width: unset;
    margin-right: 16px;
  }
`;

/**
 * @param {NavTogglerProps} props
 * @returns {React.ReactElement} The rendered component
 */
const NavToggler = ({ className, onChange, checked = false }) => {
  return (
    <Wrapper className={className} onClick={() => onChange()}>
      <Icon icon="HAMBURGER_ANIMATED" checked={checked} />
    </Wrapper>
  );
};

export default NavToggler;
